/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import ReportePanel from './ReportePanel';
import {bindActionCreators} from 'redux';
import * as tagActions from '../../actions/tagActions';
import * as comentariosActions from '../../actions/comentariosActions';
import * as inscripcionActions from '../../actions/inscripcionActions';

import toastr from 'toastr';
import ModalExamen from './ModalExamen';
import ModalAvance from './ModalAvance';
import $ from 'jquery';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import * as cursoActions from '../../actions/cursoActions';
import * as resultadoexamenActions from '../../actions/resultadoexamenActions';
import * as infoActions from '../../actions/infoActions';
import { Segment} from 'semantic-ui-react';
import {exportCSVFile} from '../common/jsonTocsv';

import {usuarioActual} from '../../util';
import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
import * as menuActions from '../../actions/menuActions';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import * as validations from '../../validations/validations';
import {getMargenes} from '../../util/';
import moment from 'moment';

class ManageExamen extends React.Component {
    constructor(props, context) {
		
		super(props, context);
        
      
        this.state={
            errors:{},
            strings:{}, 
            filtrosCombo:{},
            permisos:{} ,
            reporte:{
                emp:"",
                filtro:""
            },
            showModal:false,
            showModalAvance:false,
            quiz:null,
            curso:{
                modulos:null
                
            },
            inscripcion:{
                inscripcion:[],
            },
            inscTemp:{
                inscripcion:[],
            },
            resultadosExamen:{
                resultadosExamen:[],
                examenes:[]
            },
            datosResultado:{},
            resultadoexamen:{
                    }
		};
	}

	componentDidMount(){
        usuarioActual(this, "reporte",true).then( (usuario)=>{
            
            this.props.cursoActions.getCursoCombo(usuario).then(()=>{}) 
            .catch(error=>{ 
              toastr.error(error); 
            }); 
            
           
            
           
	   })
    }

    
    handleChangeExamen=(event, data)=>{
        
        let resultadoexamen = this.state.resultadoexamen;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		resultadoexamen[field[0]]= value;
		else{
             if(!resultadoexamen[field[0]]){
                    resultadoexamen[field[0]]={}
                }
			resultadoexamen[field[0]][field[1]]= value;
		}
        
		
        this.setState({"resultadoexamen": resultadoexamen});
        
        
    }
    
    handleChange=(event, data)=> {

        let reporte = this.state.reporte;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		reporte[field[0]]= value;
		else{
             if(!reporte[field[0]]){
                    reporte[field[0]]={}
                }
			reporte[field[0]][field[1]]= value;
		}
        
        if(field == 'cursoId'){
            this.setState({"cursoId":value});            
        /*
        
            
            reporte.emp = "";
            
            this.setState({reporte:reporte});

            this.setState({"cursoId":value});            
            this.props.inscripcionActions.getInscripcionList(value, this.props.user).then((inscripcion)=>{
                
                this.setState({inscripcion:inscripcion});
                
            })
            .catch(error=>{ 
                toastr.error(error); 
            });
            
            this.props.resultadoexamenActions.getResultadoExamen(value, this.props.user).then((resultadosExamen)=>{
                
                    this.setState({resultadosExamen:resultadosExamen});
                
            }) 
            .catch(error=>{ 
                toastr.error(error); 
            });
            
            
             this.props.inscripcionActions.getInscripcionUsuariosCombo(value, this.props.user).then(()=>{}) 
            .catch(error=>{ 
              toastr.error(error); 
            }); 
            */
            
        }
		
        this.setState({"reporte": reporte});
    }

    
    consultar=()=>{
        let reporte = this.state.reporte;
        reporte.emp = "";
        this.setState({reporte:reporte});
        
        if(reporte.filtro.trim()!=""){
          
            this.props.inscripcionActions.getInscripcionList(this.state.cursoId, reporte.filtro, this.props.user).then((inscripcion)=>{

                this.setState({inscripcion:inscripcion});

            })
            .catch(error=>{ 
                toastr.error(error); 
            });

            this.props.resultadoexamenActions.getResultadoExamen(this.state.cursoId,reporte.filtro, this.props.user).then((resultadosExamen)=>{

                    this.setState({resultadosExamen:resultadosExamen});

            }) 
            .catch(error=>{ 
                toastr.error(error); 
            });


             this.props.inscripcionActions.getInscripcionUsuariosCombo(this.state.cursoId, this.props.user).then(()=>{}) 
            .catch(error=>{ 
              toastr.error(error); 
            }); 
            
        }else{
            toastr.error("Debes capturar una palabra para realizar el filtro"); 
        }
		
       
        
        
    }
    
      
    download=()=> {
    
        let emp = this.state.reporte.emp;
        
        let lista = Object.assign({}, this.state.inscripcion);
        
        
        /*
        if(emp!=""){
            lista.inscripcion  = lista.inscripcion.filter(ins => ins.empresa!=null && ins.empresa.toUpperCase().search(emp.toUpperCase())>=0);
            
        }
        */
        
        
        if(emp!=""){
            lista.inscripcion  = lista.inscripcion.filter(ins => ins.empresa!=null &&  ins.empresa.toUpperCase().search(emp.toUpperCase())>=0 ||  ins.usuario.toUpperCase().search(emp.toUpperCase())>=0 ||  ins.mail.toUpperCase().search(emp.toUpperCase())>=0 );
            
        }  
        
        
         let listaExamen = Object.assign({}, this.state.resultadosExamen);
        /*
         if(emp!=""){
            listaExamen.examenResultado  = listaExamen.examenResultado.filter(ex => ex.empresa!=null && ex.empresa.toUpperCase().search(emp.toUpperCase())>=0);

        }  
        */
        
        let examenes = Object.assign([], listaExamen.examenes);
        
        if(emp!=""){
            if(examenes.length>0){
                listaExamen.examenResultado  = listaExamen.examenResultado.filter(ex => ex.empresa!=null && ex.empresa.toUpperCase().search(emp.toUpperCase())>=0 ||  ex.usuario.toUpperCase().search(emp.toUpperCase())>=0 );
            }else{
                listaExamen.examenResultado=[];
            }
        }  
        
        
        
        //let examenes = Object.assign([], listaExamen.examenes);
       
            var headers = {
                numero:this.state.strings["#"],
                alumno:this.state.strings["alumno"],
                profesion:this.state.strings["profesion"],
                mail:this.state.strings["mail"],
                pais:this.state.strings["pais"],
                empresa: this.state.strings["empresa"],
                telefono: this.state.strings["telefono"],
                modulosVistos: this.state.strings["modulosVistos"],
                emisionConstancia: this.state.strings["emisionConstancia"]
                
            };
       
            for(let i=0;i<examenes.length;i++){
                    headers["resultado_"+i]= "\""+examenes[i].descripcion+ "\"";                    
             }
        
            
            let itemsFormatted=[];
            
            let contador = 0;
            lista.inscripcion.forEach((item) => {
                contador++;
                let resultados=[];  
                let index = listaExamen.examenResultado.findIndex(user=>user.idUsuario == item.idUsuario);
                
                
                if(index>=0){
                    //console.log("paso el index primera vez"); 
                    //console.log(listaExamen.examenResultado[index].usuario);        
                    resultados = listaExamen.examenResultado[index];
                    //console.log(resultados);
                }
                
                
                var element = {};
                
                if(item.pais==null){ item.pais="sin dato" }
                if(item.empresa==null){ item.empresa="sin dato" }
                if(item.emisionConstancia==null){ item.emisionConstancia="sin constancia" }
                

                element['#'] = contador;
                element['alumno'] = "\""+item.usuario+ "\"";
                element['profesion'] = "\""+item.profesion+ "\"";
                element['mail'] = "\""+item.mail+ "\"";
                element['pais'] = "\""+item.pais+ "\"";
                element['empresa'] = "\""+item.empresa+ "\"";
                element['telefono'] = "\""+item.telefono+ "\"";
                element['modulosVistos'] = ((Number(item.modulosVistos)*100)/Number(lista.modulos)).toFixed(0)+ "%";
                element['emisionConstancia'] = "\""+item.emisionConstancia+ "\"";
                
                for(let k=0;k<examenes.length;k++){
                    
                    if(index>=0){
                        //console.log("paso el index");
                        for(let i=0;i<resultados.resultados.length;i++){
                            //console.log("entro");    
                            element["resultado_"+k]="";
                            if(Number(examenes[k].id) == Number(resultados.resultados[i].idForm)){
                                //console.log("entro 2");            

                                element["resultado_"+k]=(((resultados.resultados[i].correctPoints)*100)/Number(resultados.resultados[i].totalPoints)).toFixed(2)+"%";
                                break;
                            }
                        }
                    }
                }                             
                itemsFormatted.push(element);
                
                
            });

            var fileTitle = 'Reporte alumnos'; // or 'my-unique-title'
            exportCSVFile(headers, itemsFormatted, fileTitle); // call the exportCSVFile() function to process the JSON and trigger the download
   
        
    }  
    
    
    
    downloadExamen=()=> {
    
             let emp = this.state.reporte.emp;

             let lista = Object.assign({}, this.state.resultadosExamen);
                /*
             if(emp!=""){
                lista.examenResultado  = lista.examenResultado.filter(ex => ex.empresa!=null && ex.empresa.toUpperCase().search(emp.toUpperCase())>=0);
            
            }  
            */
              if(emp!=""){
                    lista.examenResultado  = lista.examenResultado.filter(ex => ex.empresa!=null && ex.empresa.toUpperCase().search(emp.toUpperCase())>=0 ||  ex.usuario.toUpperCase().search(emp.toUpperCase())>=0 );

                }  
        
            
             var headers = {};
             let examenes = lista.examenes;
             
             
             
             headers['alumno'] = this.state.strings["alumno"];     
             headers['empresa'] = this.state.strings["empresa"];    
             headers['mail'] = this.state.strings["mail"];
        
             for(let i=0;i<examenes.length;i++){
                    headers["resultado_"+i]="\""+examenes[i].descripcion+ "\"";                    
             }
             
             
            let itemsFormatted=[];
            var element = {};

            lista.examenResultado.forEach((item) => {
                element = {};
                if(item.mail==null){ item.mail="sin dato" }
                if(item.empresa==null){ item.empresa="sin dato" }
                
                
                //if(item.resultado==null){ item.resultado="No se ha realizado" }
                let resultados = item.resultados;
               
                element['alumno'] = "\""+item.usuario+ "\"";
                element['empresa'] = "\""+item.empresa+ "\"";
                element['mail'] = "\""+item.mail+ "\"";
                

                for(let k=0;k<examenes.length;k++){
                    
                    for(let i=0;i<resultados.length;i++){
                    
                        element["resultado_"+k]="";
                        if(Number(examenes[k].id) == Number(resultados[i].idForm)){
                            
                        
                            element["resultado_"+k]=(((resultados[i].correctPoints)*100)/Number(resultados[i].totalPoints)).toFixed(2)+"%";
                            break;
                        }
                            
                           

                    }
                }                             
                itemsFormatted.push(element);                          

            });

            var fileTitle = 'Rreporte examen'; // or 'my-unique-title'
            exportCSVFile(headers, itemsFormatted, fileTitle); // call the exportCSVFile() function to process the JSON and trigger the download
   
     
        
    }
    
    
    cargarExamen=(id)=>{

        
           this.props.resultadoexamenActions.getResultadoExamenUsuario(id, this.props.user).then( examen=>{
                  
                let resultado = JSON.parse(examen.cadena);
                //let resultado = examen;
                //console.log(examen);
               resultado.creadoEl = examen.creadoEl;
               
                 let errores = this.state.errores;
                    for(let i=0; i<resultado.questions.length; i++){
                       
                        
                        resultado.questions[i].userInput = resultado.userInput[i];

                    }
                   
              
               
                this.setState({"quiz":resultado, "errores": errores});
                 })
                .catch(error=>{
                  toastr.error(error);
            });
        
       
    }
    
    
    
     constancia=(inscripcionId)=>{
         
        this.props.inscripcionActions.constancia(inscripcionId, this.props.user).then((inscripcion)=>{
          
            if(inscripcion.finalizado==1){
                toastr.success('Constancia disponible para el alumno');
            }else{
                toastr.error('Constancia no disponible para el alumno');
            }    
        }) 
        .catch(error=>{ 
            toastr.error(error); 
        });
        
	}
      
    onShowExamen=(id)=>{
    
        if(id>0){
            this.cargarExamen(id);
        }
        
        this.setState({showModal:!this.state.showModal});
        
    }
    
    
    onShowAvance=(idUsuario)=>{
        
        
        if(idUsuario>0){
            this.cargarAvance(idUsuario);
        }
        
        this.setState({showModalAvance:!this.state.showModalAvance});
        
    }
    
    cambiarEstatus=(id)=>{
        this.props.inscripcionActions.cambiarEstatus(id, this.props.user).then(()=>{
           
            this.props.inscripcionActions.getInscripcionList(this.state.cursoId, this.props.user).then((inscripcion)=>{
                
                this.setState({inscripcion:inscripcion});
                
            }) 
            .catch(error=>{ 
                toastr.error(error); 
            });
            
            toastr.success('Cambio estatus realizado!!!');
            
        }) 
        .catch(error=>{ 
            toastr.error(error); 
        });
    }
    
    
    cambiarEstatusExamen=(id)=>{
        
        let idCurso = this.state.cursoId;
        
        this.props.inscripcionActions.cambiarEstatusExamen(id,idCurso,this.props.user).then(()=>{
            this.props.inscripcionActions.getInscripcionList(this.state.cursoId, this.props.user).then((inscripcion)=>{
                this.setState({inscripcion:inscripcion});
            }) 
            .catch(error=>{ 
                toastr.error(error); 
            });
            
            toastr.success('Cambio estatus realizado!!!');
            
        }) 
        .catch(error=>{ 
            toastr.error(error); 
        });
    }
    
    
    cargarAvance=(idUsuario)=>{
        let idCurso = this.state.cursoId;
    
        this.props.infoActions.getCursoDetalleUsuario(idCurso, idUsuario).then( (cursoDetalle)=>{
                let modulos=cursoDetalle.modulos;
                let contenido;
                let agrupador="";
                let fecha="";
                let contenidoViewRow={};
                let contenidoView=[];
                for(let k=0; k<modulos.length; k++){
                    contenidoView=[];
                    contenido=modulos[k].contenido;
                    agrupador="";
                    fecha="";
                    for(let i=0; i<contenido.length;i++){
                        if(agrupador!=contenido[i].agrupador || fecha!=contenido[i].fecha){
                            if(i>0){

                                contenidoView.push(contenidoViewRow);
                            }
                            agrupador=contenido[i].agrupador;
                            fecha=contenido[i].fecha;
                            contenidoViewRow={
                                agrupador:contenido[i].agrupador,
                                fecha:contenido[i].fecha,
                                contenido:[]
                            };

                        }
                        contenidoViewRow.contenido.push(contenido[i]);

                    }
                    contenidoView.push(contenidoViewRow);
                     modulos[k].contenidoView=contenidoView;
                }

                this.setState({"curso":cursoDetalle});  
            })
            .catch(error=>{
              toastr.error(error);
        });
    
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let resultadoexamen=this.state.resultadoexamen;
              
       
        if(!validations.requerido(resultadoexamen.idUsuario)){
            errors.idUsuario=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(resultadoexamen.numberOfQuestions)){
            errors.numberOfQuestions=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(resultadoexamen.numberOfCorrectAnswers)){
            errors.numberOfCorrectAnswers=true;
            formIsValid=false;
        }
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }
    
    
    onSaveCalificacion=(event)=>{
        
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
      
        let index = this.state.resultadosExamen.examenes.findIndex(ex=>ex.id == this.state.resultadoexamen.idFormulario );
        
        
        let resultadoexamen = Object.assign({}, this.state.resultadoexamen);
        resultadoexamen.idCurso = this.state.reporte.cursoId;
        resultadoexamen.idModuloContenido = this.state.resultadosExamen.examenes[index].idModuloContenido;
        
        this.props.resultadoexamenActions.saveSinCadena(resultadoexamen, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
        });
        
        
    }
    
    
    render() {
        let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
        
        let emp = this.state.reporte.emp;
        
        let inscripcion = Object.assign({}, this.state.inscripcion);
        let resultadosExamen = Object.assign({}, this.state.resultadosExamen);
        
        
        if(emp!=""){
            inscripcion.inscripcion  = inscripcion.inscripcion.filter(ins => ins.empresa!=null &&  ins.empresa.toUpperCase().search(emp.toUpperCase())>=0 ||  ins.usuario.toUpperCase().search(emp.toUpperCase())>=0 ||  ins.mail.toUpperCase().search(emp.toUpperCase())>=0 );
            
        }  
        
        if(emp!="" && resultadosExamen.examenResultado[0].id!=null){
          
            resultadosExamen.examenResultado  = resultadosExamen.examenResultado.filter(ex => ex.empresa!=null && ex.empresa.toUpperCase().search(emp.toUpperCase())>=0 ||  ex.usuario.toUpperCase().search(emp.toUpperCase())>=0 );
            
        }  
         
		return (
            <Segment   style={margenes}>
                 
                <ReportePanel
                   cambiarEstatus={this.cambiarEstatus}
                    cambiarEstatusExamen={this.cambiarEstatusExamen}
                    strings={this.props.strings}
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    id={this.state.id}
                    errores={this.state.errores}
                    cursoCombo={genericFormattedForDropdown(this.props.cursoCombo)}
                    onChange={this.handleChange}
                    reporte={this.state.reporte}
                    errors={this.state.errors}
                    inscripcion={inscripcion}
                    download={this.download}
                    downloadExamen={this.downloadExamen}    
                    resultadosExamen={resultadosExamen}
                    constancia={this.constancia}
                    onShowExamen={this.onShowExamen}
                    onShowAvance={this.onShowAvance}
                    
                    datosResultado={this.state.datosResultado}
                    inscripcionCombo={genericFormattedForDropdown(this.props.inscripcionCombo)}
                    onChangeExamen={this.handleChangeExamen}
                    onSaveExamen={this.onSaveCalificacion}
                    examenCombo={genericFormattedForDropdown(this.state.resultadosExamen.examenes)}
                    consultar={this.consultar}
                />
                
                <ModalExamen
                    showModal={this.state.showModal}
                    closeModal={this.onShowExamen}
                    quiz={this.state.quiz}
                />
                
                 <ModalAvance
                    showModal={this.state.showModalAvance}
                    closeModal={this.onShowAvance}
                    modulos={this.state.curso.modulos}
                />
            

            </Segment> 
            
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps){
    
  
    
    return {
          

        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda,
        ajaxCallInProgress:state.ajaxCallInProgress,
        color:state.color,
        form:state.form,
        color:state.color,
        strings:state.strings,
        idioma:state.idioma,
        user:state.user,
        cursoCombo:state.cursoCombo,
        inscripcion:state.inscripcion,
        resultadoexamen:state.resultadoexamen,
        inscripcionCombo:state.inscripcionCombo
    }

}


function mapDispatchToProps(dispatch){

	return { 
        menuActions:bindActionCreators(menuActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        cursoActions: bindActionCreators(cursoActions, dispatch),
        inscripcionActions: bindActionCreators(inscripcionActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        resultadoexamenActions: bindActionCreators(resultadoexamenActions, dispatch),
        infoActions: bindActionCreators(infoActions, dispatch),
 	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManageExamen);